import {
    getComponentsInCompositions,
    ComponentInformation,
    CheckedCompositionInformation,
} from 'json-react-layouts'
import { isInlineAdContent } from '../templates/Publication/lib/get-inline-positioned-ads'
import { InlineAdContent } from '../templates/Publication/SharedPublication.routing'
import {
    isAdUnitComponent,
    isPublicationComponent,
    isComponentWithInlineContentAds,
    isArticleComponent,
    isGalleryComponent,
    isFeatureComponent,
    isAmpAdUnitComponent,
} from '../__App/component-rendering/helpers'
import { TogglesReduxState } from '@news-mono/web-common'
import { isComponentEnabled } from '@news-mono/web-common'
import { Features } from '@news-mono/web-common'
import { AdDefinition } from '@news-mono/web-common'
import { toFeatureState } from '@etrigan/feature-toggles-client'

export function getRouteInfoAdUnits(
    toggles: TogglesReduxState,
    compositions: Array<CheckedCompositionInformation>,
) {
    const adUnits: AdDefinition[] = []
    const featureState = toFeatureState(toggles)
    function addAdUnits(
        component: ComponentInformation<any, any>,
        ...ads: AdDefinition[]
    ) {
        if (
            isComponentEnabled(
                featureState,
                (component as { feature?: Features }).feature,
            )
        ) {
            adUnits.push(...ads)
        }
    }

    // TODO We are filtering top level compositions, but this will *not* filter nested compositions
    // doing this will require modifying the react-json-layouts library
    for (const contentArea of getComponentsInCompositions(
        compositions.filter((composition) =>
            isComponentEnabled(
                featureState,
                (composition as { feature?: Features }).feature,
            ),
        ),
        '',
    )) {
        const component: ComponentInformation<any, any> = contentArea

        if (isAdUnitComponent(component) || isAmpAdUnitComponent(component)) {
            const adUnitProps = component.props
            addAdUnits(component, adUnitProps.slot)
        }

        // Required to pickup the ad within the west live player page
        if (component.type === 'the-west-live-player-page') {
            const adUnitProps = component.props.adUnit
            addAdUnits(component, adUnitProps.slot)
        }

        // The publication component uses a more comprehensive "inlinePublicationContent" strategy
        if (
            isPublicationComponent(component) ||
            isArticleComponent(component) ||
            isGalleryComponent(component) ||
            isFeatureComponent(component)
        ) {
            const publicationPropsMeta = component.props.meta

            if (publicationPropsMeta.kind === 'gallery') {
                addAdUnits(
                    component,
                    ...publicationPropsMeta.galleryAds.map((ad) => ad.slot),
                )
                return
            }

            const inlineContentAds = publicationPropsMeta.inlinePublicationContent
                ? publicationPropsMeta.inlinePublicationContent
                      .filter(isInlineAdContent)
                      .reduce(
                          (
                              acc: AdDefinition[],
                              contentBlock: InlineAdContent,
                          ) => {
                              acc.push(
                                  ...contentBlock.content.map((ad) => ad.slot),
                              )
                              return acc
                          },
                          [],
                      )
                : undefined

            if (inlineContentAds) {
                addAdUnits(component, ...inlineContentAds)
            }
        }
        if (isComponentWithInlineContentAds(component)) {
            const inlineContentAds = component.props.inlineContentAds.map(
                (ad) => ad.slot,
            )
            addAdUnits(component, ...inlineContentAds)
        }
    }

    return adUnits
}
